// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1gMAD","content":"GlobalSearch_content__ccPRm"};